import React, { useState } from 'react';
import styles from '../../styles/Roommates/FavoriteUnitsCarousel.module.css';

const groupFavorites = [
  { unitId: '12A', address: '320 Beacon St', neighborhood: 'Back Bay', favoritedBy: 'Olivia', favoritedOn: 'Feb 27', seen: false },
  { unitId: '7B', address: '75 Main St', neighborhood: 'Beacon Hill', favoritedBy: 'Alex', favoritedOn: 'Feb 25', seen: true },
  { unitId: '9C', address: '120 Boylston St', neighborhood: 'Fenway', favoritedBy: 'You', favoritedOn: 'Feb 24', seen: false },
  { unitId: '3D', address: '75 Brookline Ave', neighborhood: 'Fenway', favoritedBy: 'Olivia', favoritedOn: 'Feb 23', seen: true },
  { unitId: '5E', address: '45 Charles St', neighborhood: 'Beacon Hill', favoritedBy: 'Alex', favoritedOn: 'Feb 21', seen: true },
  { unitId: '2F', address: '22 Newbury St', neighborhood: 'Back Bay', favoritedBy: 'You', favoritedOn: 'Feb 20', seen: false },
];

const FavoriteUnitsCarousel = () => {
  const [isOpen, setIsOpen] = useState(false); // initially collapsed

  return (
    <div className={styles.carousel}>
      <h3 className={styles.collapsibleHeader} onClick={() => setIsOpen(!isOpen)}>
        Group Favorites {isOpen ? '▴' : '▾'}
      </h3>

      {isOpen && (
        <div className={styles.cardContainer}>
          {groupFavorites.map((unit) => (
            <div
              key={unit.unitId}
              className={`${styles.unitCard} ${!unit.seen ? styles.unseen : ''}`}
            >
              <div className={styles.unitInfo}>
                <div className={styles.unitName}>
                  {unit.unitId} – {unit.address}
                </div>
                <div className={styles.neighborhood}>
                  {unit.neighborhood}
                  {!unit.seen && <span className={styles.newBadge}>NEW</span>}
                </div>
              </div>
              <div className={styles.favoritedInfo}>
                <span className={styles.favoritedBy}>{unit.favoritedBy}</span>
                <span className={styles.favoritedOn}>{unit.favoritedOn}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FavoriteUnitsCarousel;
